import { XCircle } from '~/icons';
import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';
import { BoxSendingInfoMachineError } from '../styles';

interface ErrorSendingInfoMachine {
  isOpen: boolean;
  onClose: () => void;
}

export const ModalErrorSendingInfoMachine: React.FC<ErrorSendingInfoMachine> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      text=""
      button1={t('fechar')}
      button1Action={onClose}
      centralizedText
      imageText={(
        <BoxSendingInfoMachineError>
          <XCircle />
          <div>
            {t('erroEnviarConfiguracoesMaquina')}
          </div>
        </BoxSendingInfoMachineError>
      )}
      removeXCloseButton
    />
  );
};
